module.exports = global["$"] = require("-!/Users/danielmannheimer/plentyDevTool/23336/147/Ceres/node_modules/expose-loader/index.js?jQuery!./jquery.js");